// extracted by mini-css-extract-plugin
module.exports = {"profilePicture":"Settings_profilePicture__2koRO","profile":"Settings_profile__2wXy9","checkbox":"Settings_checkbox__1P2oU"};